import { render, staticRenderFns } from "./TermSynopsis.vue?vue&type=template&id=c3af06fa&scoped=true"
import script from "./TermSynopsis.vue?vue&type=script&lang=js"
export * from "./TermSynopsis.vue?vue&type=script&lang=js"
import style0 from "./TermSynopsis.vue?vue&type=style&index=0&id=c3af06fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3af06fa",
  null
  
)

export default component.exports